import React from 'react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import { Autoplay, EffectCoverflow, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { classNames } from '../../../utils/tailwind/classNames';
import styles from './CarouselCoverflow.module.scss';
import { NavigationButton } from './NavigationButton';
import { SlideItem, type SlideItemProps } from './SlideItem';

type CarouselCoverflowProps = {
    slides: SlideItemProps[];
};

export const CarouselCoverflow: React.FC<CarouselCoverflowProps> = ({
    slides,
}: CarouselCoverflowProps) => (
    <div
        className={classNames(
            'carousel-coverflow relative w-full overflow-hidden',
            styles.carouselCoverflow,
        )}
    >
        <Swiper
            modules={[EffectCoverflow, Navigation, Autoplay]}
            slidesPerView="auto"
            centeredSlides
            spaceBetween={0}
            loop
            grabCursor
            slideToClickedSlide
            effect="coverflow"
            autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            }}
            coverflowEffect={{
                rotate: 0,
                stretch: 30,
                depth: 130,
                modifier: 1,
                slideShadows: false,
            }}
            speed={2000}
            wrapperClass="pointer-events-none"
            breakpoints={{
                0: {
                    coverflowEffect: {
                        stretch: -20,
                    },
                },
                768: {
                    coverflowEffect: {
                        stretch: -30,
                    },
                },
                1357: {
                    coverflowEffect: {
                        stretch: -18,
                    },
                },
            }}
        >
            <NavigationButton direction="prev" />
            <NavigationButton direction="next" />
            {slides.map((slide) => (
                <SwiperSlide
                    key={slide.testId}
                    className="group pointer-events-auto flex shrink-0 items-center justify-center rounded-[1.125rem] bg-white"
                >
                    <SlideItem {...slide} />
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
);
